(() => {
  if (window.patchaidNavigationInitialized) return;
  window.patchaidNavigationInitialized = true;

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex="0"]';
  const visibleControls = (root) => [...root.querySelectorAll(focusableSelector)].filter((element) => element.getClientRects().length && !element.closest('[hidden]'));

  function showView(surface, view, returnFocus = false) {
    if (!surface) return;
    const target = surface.querySelector(`[data-nav-panel="${view}"]`);
    if (!target) return;
    surface.querySelectorAll('[data-nav-panel]').forEach((panel) => { panel.hidden = panel !== target; });
    surface.querySelectorAll('[data-nav-view]').forEach((button) => { button.setAttribute('aria-expanded', String(button.dataset.navView === view)); });
    surface.dataset.navCurrentView = view;
    const scrollArea = surface.closest('.pa-nav-mega, .pa-nav-drawer-scroll');
    if (scrollArea) scrollArea.scrollTop = 0;
    if (returnFocus) {
      const control = view === 'main' ? surface.navPreviousControl : target.querySelector('[data-nav-back]');
      if (control && control.getClientRects().length) control.focus();
    }
  }

  function closeDisclosure(disclosure, restoreFocus = false) {
    disclosure.open = false;
    disclosure.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    showView(disclosure.querySelector('[data-nav-surface]'), 'main');
    if (restoreFocus) disclosure.querySelector(':scope > summary')?.focus();
  }

  function initialize() {
    document.querySelectorAll('[data-nav-disclosure]').forEach((disclosure) => {
      if (disclosure.dataset.navReady) return;
      disclosure.dataset.navReady = 'true';
      const summary = disclosure.querySelector(':scope > summary');
      summary.setAttribute('aria-expanded', String(disclosure.open));
      disclosure.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(disclosure.open));
        if (disclosure.open) {
          document.querySelectorAll('[data-nav-disclosure][open]').forEach((other) => { if (other !== disclosure) closeDisclosure(other); });
        } else {
          showView(disclosure.querySelector('[data-nav-surface]'), 'main');
        }
      });
      summary.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        disclosure.open = true;
        visibleControls(disclosure).find((control) => control !== summary)?.focus();
      });
      disclosure.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (disclosure.open && !disclosure.contains(document.activeElement)) closeDisclosure(disclosure);
        });
      });
    });

    const drawer = document.querySelector('[data-nav-drawer]');
    const trigger = document.querySelector('[data-nav-open]');
    if (!drawer || !trigger || drawer.dataset.navReady) return;
    drawer.dataset.navReady = 'true';
    trigger.addEventListener('click', () => {
      if (drawer.open) return;
      document.querySelectorAll('[data-nav-disclosure][open]').forEach((disclosure) => closeDisclosure(disclosure));
      showView(drawer.querySelector('[data-nav-surface]'), 'main');
      drawer.showModal();
      document.documentElement.classList.add('pa-nav-drawer-open');
      trigger.setAttribute('aria-expanded', 'true');
      drawer.querySelector('[data-nav-close]')?.focus();
    });
    drawer.querySelector('[data-nav-close]').addEventListener('click', () => drawer.close());
    drawer.addEventListener('close', () => {
      document.documentElement.classList.remove('pa-nav-drawer-open');
      trigger.setAttribute('aria-expanded', 'false');
      showView(drawer.querySelector('[data-nav-surface]'), 'main');
      if (trigger.getClientRects().length && !drawer.dataset.navExternalHandoff) trigger.focus();
      delete drawer.dataset.navExternalHandoff;
    });
    drawer.addEventListener('cancel', (event) => {
      const surface = drawer.querySelector('[data-nav-surface]');
      if (surface.dataset.navCurrentView && surface.dataset.navCurrentView !== 'main') {
        event.preventDefault();
        showView(surface, 'main', true);
      }
    });
    drawer.addEventListener('click', (event) => {
      if (event.target !== drawer) return;
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const controls = visibleControls(drawer);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
  }

  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-gorgias-chat-link], .opensearchbox, [data-nav-link="account"]')) return;
    const drawer = document.querySelector('[data-nav-drawer][open]');
    if (!drawer) return;
    drawer.dataset.navExternalHandoff = 'true';
    document.documentElement.classList.remove('pa-nav-drawer-open');
    drawer.close();
  }, true);

  document.addEventListener('click', (event) => {
    const viewButton = event.target.closest('[data-nav-view]');
    const backButton = event.target.closest('[data-nav-back]');
    if (viewButton) {
      const surface = viewButton.closest('[data-nav-surface]');
      surface.navPreviousControl = viewButton;
      showView(surface, viewButton.dataset.navView, true);
    } else if (backButton) {
      showView(backButton.closest('[data-nav-surface]'), 'main', true);
    }
    document.querySelectorAll('[data-nav-disclosure][open]').forEach((disclosure) => {
      if (!disclosure.contains(event.target)) closeDisclosure(disclosure);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('[data-nav-disclosure][open]');
    if (!disclosure) return;
    event.preventDefault();
    const surface = disclosure.querySelector('[data-nav-surface]');
    if (surface?.dataset.navCurrentView && surface.dataset.navCurrentView !== 'main') showView(surface, 'main', true);
    else closeDisclosure(disclosure, true);
  });

  window.matchMedia('(min-width: 1024px)').addEventListener('change', (event) => {
    if (event.matches) document.querySelector('[data-nav-drawer][open]')?.close();
    else document.querySelectorAll('[data-nav-disclosure][open]').forEach((disclosure) => closeDisclosure(disclosure));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-nav-drawer]')) document.documentElement.classList.remove('pa-nav-drawer-open');
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
